import { GridCellParams } from '@mui/x-data-grid-premium'

export const getDealCellClassNames = (params: GridCellParams) => {
  const classes: string[] = []

  if (
    params.field === 'daysLeft' &&
    params?.row?.daysLeft > 0 &&
    params?.row?.daysLeft <= 30 &&
    ['Active', 'Pending'].includes(params?.row?.dealStatus) &&
    params?.row?.stage === 'Deal Won'
    // &&
    // params?.row?.status !== 'Completed Internally'
  ) {
    classes.push('deal-cell-warning')
  }

  return classes.join(' ')
}
